import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { CalendarCheck } from 'lucide-react';
import Dialog from '../ui/Dialog';
import { useMonthApprovalStatus } from './useMonthApprovalStatus';
import { gateShowsOn, monthApprovalPath } from './monthApprovalModel';
import { formatMonthName } from './monthLabels';

/**
 * D-319 s.1 - "צריך לאשר את נוכחות {חודש}": a window in the middle of the screen, with no ✕ and no
 * closing by a click outside (dismissible={false}), for every employee (managers included) with a
 * month that ended and was not approved. One button, to the approval. It comes back on every page
 * change and every refresh until the month is approved.
 */
export default function MonthApprovalGate() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { status, refetch } = useMonthApprovalStatus();

  // Every page change asks again (an approval on another tab / by Claude closes it).
  useEffect(() => { void refetch(); }, [location.pathname, refetch]);

  const open = gateShowsOn(location.pathname, status);
  const month = status?.pending[0];
  if (!open || !month) return null;
  const name = formatMonthName(month.month, i18n.language);
  return (
    <Dialog
      open
      onClose={() => undefined}
      dismissible={false}
      hideCloseButton
      role="alertdialog"
      size="sm"
      icon={<CalendarCheck size={18} aria-hidden="true" />}
      title={month.attendance_done ? t('monthApproval.gate.titleLogsOnly', { month: name }) : month.reopened ? t('monthApproval.gate.titleReopened', { month: name }) : t('monthApproval.gate.title', { month: name })}
      footer={(
        <button
          type="button"
          className="btn btn-primary w-full sm:w-auto"
          data-testid="month-approval-gate-go"
          onClick={() => navigate(monthApprovalPath(month.month))}
        >
          {month.attendance_done ? t('monthApproval.gate.goLogs') : t('monthApproval.gate.go')}
        </button>
      )}
    >
      <div data-testid="month-approval-gate" className="space-y-2 text-sm text-text">
        <p>{month.attendance_done ? t('monthApproval.gate.bodyLogsOnly') : month.logs_required ? t('monthApproval.gate.bodyLogs') : t('monthApproval.gate.body')}</p>
      </div>
    </Dialog>
  );
}
